import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    isLoading: false,
    showMask: false,
    timeDiff: 0,
    user : null,
    wxUser: null,
    userFeature: null,
    dataList:null,
}

export const types = {
    UPDATE_LOADING: 'UPDATE_LOADING',
    UPDATE_MASK: 'UPDATE_MASK',
    UPDATE_DIRECTION: 'UPDATE_DIRECTION',
    SET_SERVER_TIME: 'SET_SERVER_TIME',
    SET_USER: 'SET_USER',
    SET_WX_USER: 'SET_WX_USER',
    SET_USER_FEATURE: 'SET_USER_FEATURE',
    SET_DATA_LIST:'SET_DATA_LIST'
}

const mutations = {
    [types.UPDATE_LOADING] (state, status) {
        state.isLoading = status
    },
    [types.UPDATE_MASK] (state, status) {
        state.showMask = status
    },
    [types.SET_SERVER_TIME] (state, data) {
        state.timeDiff = data - new Date().getTime()
    },
    [types.SET_USER] (state, user) {
        state.user = user
    },
    [types.SET_WX_USER] (state, wxUser) {
      state.wxUser = wxUser
    },
    [types.SET_USER_FEATURE] (state, features) {
        state.userFeature = features
    },
    [types.SET_DATA_LIST](state,data){
        state.dataList=data
    }
}

const actions = {}

const getters = {
    currentTime(state){
        var local = new Date().getTime();
        return state.timeDiff + local;
    },
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    strict: false
})



// WEBPACK FOOTER //
// ./src/store/index.js